import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('mappingManagementStore')
@observer
class MappingManagement extends Component {
  state = {
  }
  componentDidMount() {
  }
  render() {
    const { mappingManagementStore, location } = this.props
    const { isFetching } = mappingManagementStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default MappingManagement;
